import React from 'react';
import CompactNullView from './CompactNullView';
import DesktopNullView from './DesktopNullView';
import { useQuoteContext } from '../../../hooks/useQuoteContext';
import fallbackViewTexts from '../../../constants/fallbackViewTexts';

const QuotesNullView = () => {
  const { isMobile } = useQuoteContext();

  const { imageAlt, imageUrl } = fallbackViewTexts;

  return (
    <div className="sui-@container sui-h-full">
      {isMobile ? (
        <div className="sui-h-full">
          <CompactNullView
            imageUrl={imageUrl}
            imageAlt={imageAlt}
          />
        </div>
      ) : (
        <div className="sui-h-full">
          <DesktopNullView
            imageUrl={imageUrl}
            imageAlt={imageAlt}
          />
        </div>
      )}
    </div>
  );
};

QuotesNullView.propTypes = {};
QuotesNullView.defaultProps = {};

export default QuotesNullView;
